/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomNbTimePickerDirective } from './timepicker.directive';
import { CustomNbTimePickerComponent } from './timepicker.component';
import { CustomNbTimePickerCellComponent } from './timepicker-cell.component';
import { NB_TIME_PICKER_CONFIG, NbTimePickerConfig } from './model';
import { NbAuthModule } from '@nebular/auth';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import { NbCardModule, NbIconModule, NbPopoverModule, NbSpinnerModule, NbCalendarRangeModule, NbInputModule, NbButtonModule, NbAlertModule, NbCheckboxModule, NbLayoutModule, NbBadgeModule, NbActionsModule, NbUserModule, NbListModule, NbDatepickerModule, NbCalendarModule, NbSelectModule, NbAutocompleteModule, NbCalendarKitModule, NbCalendarTimeModelService, NbOverlayModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

@NgModule({
    imports: [
        CommonModule,
        NbCardModule,
        NbIconModule,
        NbPopoverModule,
        NbEvaIconsModule,
        NbSpinnerModule,
        NbCalendarRangeModule,
        NbInputModule,
        NbButtonModule,
        NbAlertModule,
        NbCheckboxModule,
        NbAuthModule,
        NbLayoutModule,
        NbBadgeModule,
        NbActionsModule,
        NbUserModule,
        NbListModule,
        NbDatepickerModule,
        NbCalendarModule,
        Ng2SmartTableModule,
        NbSelectModule,
        NbAutocompleteModule,
        NbDateFnsDateModule,
        NbSecurityModule,
        NbCalendarKitModule,
        NbOverlayModule
    ],
    providers: [NbCalendarTimeModelService],
    exports: [CustomNbTimePickerComponent, CustomNbTimePickerCellComponent, CustomNbTimePickerDirective],
    declarations: [CustomNbTimePickerComponent, CustomNbTimePickerCellComponent, CustomNbTimePickerDirective],
})
export class CustomNbTimepickerModule {
    static forRoot(config: NbTimePickerConfig = {}): ModuleWithProviders<CustomNbTimepickerModule> {
        return {
            ngModule: CustomNbTimepickerModule,
            providers: [{ provide: NB_TIME_PICKER_CONFIG, useValue: config }],
        };
    }

    static forChild(config: NbTimePickerConfig = {}): ModuleWithProviders<CustomNbTimepickerModule> {
        return {
            ngModule: CustomNbTimepickerModule,
            providers: [{ provide: NB_TIME_PICKER_CONFIG, useValue: config }],
        };
    }
}
